import React, { useContext } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Button } from 'react-native-elements';
import { useNavigation } from '@react-navigation/native';

import { Context as ConcertContext } from '../context/ConcertContext';
import MaskedImageContainer from '../components/MaskedImageContainer';
import { deviceWidth } from '../helpers/deviceHelper';
import { dateElementsExtractor } from '../helpers/dateHelper';

const styles = StyleSheet.create({
  sectionContainer: {
    // borderColor: 'red',
    // borderWidth: 5,
    backgroundColor: 'white',
    alignItems: 'center',
  },
  sectionHeaderContainer: {
    height: deviceWidth * 0.3,
    padding: deviceWidth * 0.05,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionHeaderText: {
    fontFamily: 'MPLUS1p_400Regular',
    fontSize: 30,
  },
  container: {
    alignItems: 'center',
    marginBottom: deviceWidth * 0.1,
  },
  dateBox: {
    position: 'absolute',
    zIndex: 2,
    left: deviceWidth * 0,
    width: deviceWidth * 0.2,
    height: deviceWidth * 0.2,
    backgroundColor: '#3e67c5',
    justifyContent: 'center',
    alignItems: 'center',
  },
  monthText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 20,
  },

  dayText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 30,
  },
  detailButton: {
    width: deviceWidth * 0.6,
  },
});
export default function Upcoming() {
  const { state } = useContext(ConcertContext);
  const navigation = useNavigation();

  const upcomingConcert = state.map(({ id, content }) => {
    // const { month, day } = dateElementExtractor(new Date(content.date));
    const { month, day } = dateElementsExtractor(new Date(content.date));
    return (
      <View key={id} style={styles.container}>
        <View style={styles.dateBox}>
          <Text style={styles.monthText}>{`${month}月`}</Text>
          <Text style={styles.dayText}>{`${day}`}</Text>
        </View>
        <MaskedImageContainer
          uri={content.imageUrl[0]}
          imageProportionType="a4"
          imageWidthRelativeToDeviceWidth={0.6}
          maskWidthRelativeToDeviceWidth={0.6}
          containerWidthRelativeToDeviceWidth={0.8}
        />

        <Button
          style={styles.detailButton}
          type="outline"
          title="詳細"
          onPress={() => {
            const {
              imageUrl,
              title,
              date,
              time,
              venue,
              price,
              description,
              bookingFormLink,
              bookingAccept,
              bookingPhoneNumber,
              bookingEmail,
            } = content;

            navigation.navigate('ConcertDetail', {
              imageUrl,
              title,
              date,
              time,
              venue,
              price,
              description,
              bookingFormLink,
              bookingAccept,
              bookingPhoneNumber,
              bookingEmail,
            });
          }}
        />
      </View>
    );
  });

  return (
    <View style={styles.sectionContainer}>
      <View style={styles.sectionHeaderContainer}>
        <Text style={styles.sectionHeaderText}>コンサートの予定</Text>
      </View>
      {upcomingConcert}
    </View>
  );
}
